import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import { HelpCircle, AlertCircle, Search } from "lucide-react";
import { PieChart, Pie, Cell } from "recharts";
import api from '../../service/api';
import '../../css/style.css';
import '../../css/Antropometria.css';

import AnatomiaHomemW from '../../images/Anatomia-homem-w.png';
import AnatomiaHomemB from '../../images/Anatomia-homem-b.png';
import AnatomiaMulherW from '../../images/Anatomia-mulher-w.png';
import AnatomiaMulherB from '../../images/Anatomia-mulher-b.png';

import FitaMetrica from '../../images/fita.png';
import Indicador from '../../images/indicador.png';

import ImagemConicidade from '../../images/novo-cone-sem-logo.png'; // Representação gráfica única (bicôncavo, cilíndrico e bicônico), sem as logos
import { formatarNumero } from '../../utils/formato';

function AntropometriaGeral({ setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {
    // Navegação entre etapas
    const [etapa, setEtapa] = useState(1);
    const totalEtapas = 4;
    const porcentagemConclusao = (etapa / totalEtapas) * 100;

    const avancarEtapa = () => {
        setFitaVisivel(false);
        setShowInfoLegendaCorpo("");
        setEtapa(etapa + 1);
    };

    const retrocederEtapa = () => {
        if (etapa > 1) {
            setEtapa(etapa - 1);
        }
    };

    // Modal para próxima etapa
    const [isNextModal, setIsNextModal] = useState(false);
    const openNextModal = () => {
        setIsNextModal(true);
    };
    const closeNextModal = () => {
        setIsNextModal(false);
    };

    // Popups de informações
    const [showInfo, setShowInfo] = useState(false);
    const [showProcedimentos, setShowProcedimentos] = useState(false);

    const [imagemAnatomia, setImagemAnatomia] = useState(false);

    const [showInfoPescoço, setShowInfoPescoço] = useState(false);
    const [showInfoOmbro, setShowInfoOmbro] = useState(false);
    const [showInfoToraxNormal, setShowInfoToraxNormal] = useState(false);
    const [showInfoToraxInspirado, setShowInfoToraxInspirado] = useState(false);
    const [showInfoAbdomen, setShowInfoAbdomen] = useState(false);
    const [showInfoCintura, setShowInfoCintura] = useState(false);
    const [showInfoQuadril, setShowInfoQuadril] = useState(false);
    const [showInfoCoxaDP, setShowInfoCoxaDP] = useState(false);
    const [showInfoCoxaDM, setShowInfoCoxaDM] = useState(false);
    const [showInfoCoxaEP, setShowInfoCoxaEP] = useState(false);
    const [showInfoCoxaEM, setShowInfoCoxaEM] = useState(false);
    const [showInfoPernaD, setShowInfoPernaD] = useState(false);
    const [showInfoPernaE, setShowInfoPernaE] = useState(false);
    const [showInfoBracoDR, setShowInfoBracoDR] = useState(false);
    const [showInfoBracoDC, setShowInfoBracoDC] = useState(false);
    const [showInfoBracoER, setShowInfoBracoER] = useState(false);
    const [showInfoBracoEC, setShowInfoBracoEC] = useState(false);
    const [showInfoAntebracoD, setShowInfoAntebracoD] = useState(false);
    const [showInfoAntebracoE, setShowInfoAntebracoE] = useState(false);
    const [showInfoPunhoD, setShowInfoPunhoD] = useState(false);
    const [showInfoPunhoE, setShowInfoPunhoE] = useState(false);

    const [showInfoLegendaCorpo, setShowInfoLegendaCorpo] = useState("");

    const [showInfoIMC, setShowInfoIMC] = useState(false);
    const [showInfoCircunferenciaAbdominal, setShowInfoCircunferenciaAbdominal] = useState(false);
    const [showInfoIRCQ, setShowInfoIRCQ] = useState(false);
    const [showInfoICA, setShowInfoICA] = useState(false);
    const [showInfoIAC, setShowInfoIAC] = useState(false);
    const [showInfoConicidade, setShowInfoConicidade] = useState(false);
    const [showImgConicidade, setShowImgConicidade] = useState("");
    // A imagem abre centralizada na tela, longe do botão: o fechamento tem um pequeno atraso
    // para o mouse conseguir chegar até ela sem que ela suma.
    const timerImgConicidade = useRef(null);
    const abrirImgConicidade = () => {
        if (timerImgConicidade.current) clearTimeout(timerImgConicidade.current);
        setShowImgConicidade(true);
    };
    const fecharImgConicidade = () => {
        timerImgConicidade.current = setTimeout(() => setShowImgConicidade(false), 200);
    };
    const [showInfoPesoIdeal, setShowInfoPesoIdeal] = useState(false);
    const [showInfoTMB, setShowInfoTMB] = useState(false);
    const [showInfoTMD, setShowInfoTMD] = useState(false);
    const [showInfoGET, setShowInfoGET] = useState(false);

    // Aluna exemplo; Gabriela
    /*
    const [peso, setPeso] = useState(55.9);
    const [perfil, setPerfil] = useState("homensEMulheresAdultos");
    const [idade, setIdade] = useState(34);
    const [altura, setAltura] = useState(160);
    const [sexo, setSexo] = useState('Feminino')
    const [IMC, setIMC] = useState(21.8)
    const [pescoco, setPescoco] = useState(38);
    const [abdomen, setAbdomen] = useState(82);
    const [cintura, setCintura] = useState(73.5);
    const [quadril, setQuadril] = useState(91.5);
    */


    // Capitaliza primeiro caractere para compatibilidade com posicoesFita e cálculos ('masculino' → 'Masculino')
    const capitalizarSexo = (s) => s ? s.charAt(0).toUpperCase() + s.slice(1) : 'Feminino';

    const [sexo, setSexo] = useState(capitalizarSexo(aluno?.sexo));
    const [peso, setPeso] = useState();
    const [idade, setIdade] = useState(Number(aluno?.idade) || 0);
    const [altura, setAltura] = useState();
    const [fatorAtividade, setFatorAtividade] = useState("sedentario");

    const [pescoço, setPescoço] = useState();
    const [ombro, setOmbro] = useState();
    const [toraxNormal, setToraxNormal] = useState();
    const [toraxInspirado, setToraxInspirado] = useState();
    const [abdomen, setAbdomen] = useState();
    const [cintura, setCintura] = useState();
    const [quadril, setQuadril] = useState();

    const [coxaDproximal, setCoxaDproximal] = useState();
    const [coxaEproximal, setCoxaEproximal] = useState();
    const [coxaDmedial, setCoxaDmedial] = useState();
    const [coxaEmedial, setCoxaEmedial] = useState();

    const [pernaD, setPernaD] = useState();
    const [pernaE, setPernaE] = useState();
    const [bracoDrelaxado, setBracoDrelaxado] = useState();
    const [bracoErelaxado, setBracoErelaxado] = useState();
    const [bracoDcontraido, setBracoDcontraido] = useState();
    const [bracoEcontraido, setBracoEcontraido] = useState();
    const [antebracoD, setAntebracoD] = useState();
    const [antebracoE, setAntebracoE] = useState();
    const [punhoD, setPunhoD] = useState();
    const [punhoE, setPunhoE] = useState();

    const [imc, setImc] = useState(0);
    const [IRCQ, setIRCQ] = useState(0);
    const [ICA, setICA] = useState(0);
    const [IAC, setIAC] = useState(0);
    const [conicidade, setConicidade] = useState(0);
    const [pesoIdeal, setPesoIdeal] = useState(0);
    const [TMB, setTMB] = useState(0);
    const [GET, setGET] = useState(0);

    // Movimenta a fita no corpo na coleta de dados
    const fitaRef = useRef(null);
    const [fitaVisivel, setFitaVisivel] = useState(false);

    const posicoesFita = {
        Masculino: {
            Pescoço: { x: 0, y: 56, largura: 32, angulo: 0 },
            Ombro: { x: 0, y: 82, largura: 116, angulo: 0 },
            Torax: { x: 0, y: 98, largura: 74, angulo: 0 },
            Cintura: { x: 0, y: 142, largura: 62, angulo: 0 },
            Abdomen: { x: 0, y: 150, largura: 64, angulo: 0 },
            Quadril: { x: 0, y: 180, largura: 76, angulo: 0 },
            CoxaProximalE: { x: 20, y: 194, largura: 42, angulo: -7 },
            CoxaMedialE: { x: 24, y: 224, largura: 41, angulo: -4 },
            CoxaProximalD: { x: -22, y: 194, largura: 42, angulo: 7 },
            CoxaMedialD: { x: -25, y: 224, largura: 41, angulo: 4 },
            PernaE: { x: 26, y: 294, largura: 32, angulo: 0 },
            PernaD: { x: -27, y: 294, largura: 32, angulo: 0 },
            BraçoRelaxadoE: { x: 50, y: 112, largura: 26, angulo: -12 },
            BraçoContraidoE: { x: 50, y: 112, largura: 26, angulo: -12 },
            BraçoRelaxadoD: { x: -50, y: 112, largura: 26, angulo: 12 },
            BraçoContraidoD: { x: -50, y: 112, largura: 26, angulo: 12 },
            AntebraçoE: { x: 57, y: 146, largura: 25, angulo: -12 },
            PunhoE: { x: 66, y: 183, largura: 14, angulo: -5 },
            AntebraçoD: { x: -58, y: 146, largura: 25, angulo: 12 },
            PunhoD: { x: -67, y: 183, largura: 14, angulo: 5 },
        },

        Feminino: {
            Pescoço: { x: 0, y: 64, largura: 23, angulo: 0 },
            Ombro: { x: 0, y: 86, largura: 99, angulo: 0 },
            Torax: { x: 0, y: 104, largura: 66, angulo: 0 },
            Cintura: { x: 0, y: 140, largura: 51, angulo: 0 },
            Abdomen: { x: 0, y: 156, largura: 64, angulo: 0 },
            Quadril: { x: 0, y: 185, largura: 80, angulo: 0 },
            CoxaProximalE: { x: 22, y: 198, largura: 42, angulo: -7 },
            CoxaMedialE: { x: 23, y: 224, largura: 38, angulo: -4 },
            CoxaProximalD: { x: -22, y: 198, largura: 42, angulo: 7 },
            CoxaMedialD: { x: -23, y: 224, largura: 38, angulo: 4 },
            PernaE: { x: 23, y: 299, largura: 28, angulo: 0 },
            PernaD: { x: -23, y: 299, largura: 28, angulo: 0 },
            BraçoRelaxadoE: { x: 44, y: 117, largura: 21, angulo: -12 },
            BraçoContraidoE: { x: 44, y: 117, largura: 21, angulo: -12 },
            BraçoRelaxadoD: { x: -44, y: 117, largura: 21, angulo: 12 },
            BraçoContraidoD: { x: -44, y: 117, largura: 21, angulo: 12 },
            AntebraçoE: { x: 53, y: 148, largura: 21, angulo: -14 },
            PunhoE: { x: 63, y: 183, largura: 11, angulo: -5 },
            AntebraçoD: { x: -53, y: 148, largura: 21, angulo: 14 },
            PunhoD: { x: -64, y: 183, largura: 11, angulo: 5 },
        }
    };

    const moverFitaPorItem = (sexo, item) => {
        const posicao = posicoesFita[sexo]?.[item];

        if (!posicao) {
            console.warn(`Posição não encontrada para sexo: ${sexo}, item: ${item}`);
            return;
        }

        const { x, y, largura, angulo } = posicao;

        if (fitaRef.current) {
            const corte = (180 - largura) / 2;
            fitaRef.current.style.left = `${x}px`;
            fitaRef.current.style.top = `${y}px`;
            fitaRef.current.style.clipPath = `inset(0 ${corte}px 0 ${corte}px)`;
            fitaRef.current.style.transform = `rotate(${angulo}deg)`;
            setFitaVisivel(true);
        }

        const itemBase = item.replace(/(E|D)$/, "");
        setShowInfoLegendaCorpo(itemBase);
    };

    // Escolhe a imagem do corpo de acordo com a situação
    const trocaImagemAnatomia = () => {
        if (sexo === "Masculino") {
            setImagemAnatomia(AnatomiaHomemW);
        }
        else {
            setImagemAnatomia(AnatomiaMulherW);
        }
    }

    // Cria o gráfico de barra com o indicador
    const GraficoBarraComIndicador = ({
        valor,
        faixas,
        largura = 340,
        altura = 25,
        corIndicador = "#fff",
        mostrarValor = false,
    }) => {
        const larguraSegmento = largura / faixas.length;

        // Encontra a faixa correspondente ao valor
        const faixaIndex = faixas.findIndex(
            (faixa) => valor >= faixa.range[0] && valor <= faixa.range[1]
        );

        let posicaoSeta = 0;

        if (faixaIndex !== -1) {
            const faixa = faixas[faixaIndex];
            const [min, max] = faixa.range;
            const percentualNaFaixa = (valor - min) / (max - min); // valor entre 0 e 1

            posicaoSeta = faixaIndex * larguraSegmento + percentualNaFaixa * larguraSegmento;
        }

        return (
            <div style={{ position: "relative", marginTop: "0px" }}>
                {/* Indicador (seta) */}
                <div
                    style={{
                        position: "absolute",
                        left: `${posicaoSeta}px`,
                        top: "10px",
                        transform: "translateX(-50%) translateY(-14px)",
                        fontSize: "20px",
                        color: corIndicador,
                        whiteSpace: "nowrap",
                    }}
                >
                    <img className="indicador-img" src={Indicador} alt="▲" />
                    {mostrarValor && formatarNumero(valor, 1)}
                </div>

                {/* Barra segmentada com faixas de largura igual ▲ <img className="arrow-icon" src={LeviIcon} alt="corpo-humano" />*/}
                <div
                    style={{
                        display: "flex",
                        height: `${altura}px`,
                        width: `${largura}px`,
                        overflow: "hidden",
                        boxShadow: "0 0 4px rgba(0,0,0,0.1)",
                    }}
                >
                    {faixas.map((faixa, index) => {
                        const borderRadiusStyle = {
                            borderTopLeftRadius: index === 0 ? "2px" : "0px",
                            borderBottomLeftRadius: index === 0 ? "2px" : "0px",
                            borderTopRightRadius: index === faixas.length - 1 ? "2px" : "0px",
                            borderBottomRightRadius: index === faixas.length - 1 ? "2px" : "0px",
                        };

                        return (
                            <div
                                key={index}
                                style={{
                                    width: `${larguraSegmento}px`,
                                    backgroundColor: faixa.color,
                                    ...borderRadiusStyle,
                                }}
                                title={`${faixa.name} (${faixa.range[0]} - ${faixa.range[1]})`}
                            />
                        );
                    })}
                </div>
            </div>
        );
    };

    // Encontra as faixas mais gerais de classificação pra exibir nos resultados
    function encontrarFaixa(valor, faixas) {
        return faixas.find((faixa) =>
            valor >= faixa.range[0] && valor <= faixa.range[1]
        );
    }


    // ------- Formulas e dados dos resultados ------- 

    // ---------- IMC ---------- 
    const faixasIMC = [
        { name: "Abaixo do peso", range: [0, 18.4], color: "#66a3ff" },
        { name: "Peso Normal", range: [18.5, 24.9], color: "#00c457" },
        { name: "Sobrepeso", range: [25, 29.9], color: "#ffbb28" },
        { name: "Obesidade 1", range: [30, 34.9], color: "#ff8042" },
        { name: "Obesidade 2", range: [35, 39.9], color: "#fb1d1d" },
        { name: "Obesidade 3", range: [40, 80], color: "#d30202" },
    ];

    const calcularIMC = () => {
        const pesoFloat = parseFloat(peso);
        const alturaEmMetros = parseFloat(altura) / 100;
        const imcCalculado = pesoFloat / (alturaEmMetros * alturaEmMetros);
        setImc(formatarNumero(imcCalculado, 2));
    };

    // ---------- Circunferencia abdmonial ---------- 
    const faixasAbdomen = [
        { name: "Baixo risco para desenvolver doenças cardiovasculares", range: [0, 94], color: "#00c457" },
        { name: "Risco aumentado para doenças desenvolver cardiovasculares", range: [94.1, 102], color: "#ffbb28" },
        { name: "Risco muito aumentado para doenças desenvolver cardiovasculares", range: [102.1, 300], color: "#d30202" },
    ];

    // ---------- IRCQ ---------- 
    const faixasRCQPorIdadeHomem = [
        {
            idadeMin: 10,
            idadeMax: 29,
            faixas: [
                { name: "Risco baixo para desenvolver doenças cardiometabólicas", range: [0, 0.83], color: "#00c457" },
                { name: "Risco moderado para desenvolver doenças cardiometabólicas", range: [0.83, 0.88], color: "#ffbb28" },
                { name: "Risco alto para desenvolver doenças cardiometabólicas", range: [0.89, 0.94], color: "#ff8042" },
                { name: "Risco muito alto para desenvolver doenças cardiometabólicas", range: [0.95, 1.1], color: "#d30202" },
            ],
        },
        {
            idadeMin: 30,
            idadeMax: 39,
            faixas: [
                { name: "Risco baixo para desenvolver doenças cardiometabólicas", range: [0, 0.84], color: "#00c457" },
                { name: "Risco moderado para desenvolver doenças cardiometabólicas", range: [0.84, 0.91], color: "#ffbb28" },
                { name: "Risco alto para desenvolver doenças cardiometabólicas", range: [0.92, 0.96], color: "#ff8042" },
                { name: "Risco muito alto para desenvolver doenças cardiometabólicas", range: [0.97, 1.1], color: "#d30202" },
            ],
        },
        {
            idadeMin: 40,
            idadeMax: 49,
            faixas: [
                { name: "Risco baixo para desenvolver doenças cardiometabólicas", range: [0, 0.88], color: "#00c457" },
                { name: "Risco moderado para desenvolver doenças cardiometabólicas", range: [0.88, 0.95], color: "#ffbb28" },
                { name: "Risco alto para desenvolver doenças cardiometabólicas", range: [0.96, 1.0], color: "#ff8042" },
                { name: "Risco muito alto para desenvolver doenças cardiometabólicas", range: [1.01, 1.1], color: "#d30202" },
            ],
        },
        {
            idadeMin: 50,
            idadeMax: 59,
            faixas: [
                { name: "Risco baixo para desenvolver doenças cardiometabólicas", range: [0, 0.90], color: "#00c457" },
                { name: "Risco moderado para desenvolver doenças cardiometabólicas", range: [0.90, 0.96], color: "#ffbb28" },
                { name: "Risco alto para desenvolver doenças cardiometabólicas", range: [0.97, 1.02], color: "#ff8042" },
                { name: "Risco muito alto para desenvolver doenças cardiometabólicas", range: [1.03, 1.1], color: "#d30202" },
            ],
        },
        {
            idadeMin: 60,
            idadeMax: 100,
            faixas: [
                { name: "Risco baixo para desenvolver doenças cardiometabólicas", range: [0, 0.91], color: "#00c457" },
                { name: "Risco moderado para desenvolver doenças cardiometabólicas", range: [0.91, 0.98], color: "#ffbb28" },
                { name: "Risco alto para desenvolver doenças cardiometabólicas", range: [0.99, 1.03], color: "#ff8042" },
                { name: "Risco muito alto para desenvolver doenças cardiometabólicas", range: [1.04, 1.1], color: "#d30202" },
            ],
        },
    ];

    const faixasRCQPorIdadeMulheres = [
        {
            idadeMin: 10,
            idadeMax: 29,
            faixas: [
                { name: "Risco baixo para desenvolver doenças cardiometabólicas", range: [0, 0.71], color: "#00c457" },
                { name: "Risco moderado para desenvolver doenças cardiometabólicas", range: [0.71, 0.77], color: "#ffbb28" },
                { name: "Risco alto para desenvolver doenças cardiometabólicas", range: [0.78, 0.82], color: "#ff8042" },
                { name: "Risco muito alto para desenvolver doenças cardiometabólicas", range: [0.83, 1], color: "#d30202" },
            ],
        },
        {
            idadeMin: 30,
            idadeMax: 39,
            faixas: [
                { name: "Risco baixo para desenvolver doenças cardiometabólicas", range: [0, 0.72], color: "#00c457" },
                { name: "Risco moderado para desenvolver doenças cardiometabólicas", range: [0.72, 0.78], color: "#ffbb28" },
                { name: "Risco alto para desenvolver doenças cardiometabólicas", range: [0.79, 0.84], color: "#ff8042" },
                { name: "Risco muito alto para desenvolver doenças cardiometabólicas", range: [0.85, 1], color: "#d30202" },
            ],
        },
        {
            idadeMin: 40,
            idadeMax: 49,
            faixas: [
                { name: "Risco baixo para desenvolver doenças cardiometabólicas", range: [0, 0.73], color: "#00c457" },
                { name: "Risco moderado para desenvolver doenças cardiometabólicas", range: [0.73, 0.79], color: "#ffbb28" },
                { name: "Risco alto para desenvolver doenças cardiometabólicas", range: [0.80, 0.87], color: "#ff8042" },
                { name: "Risco muito alto para desenvolver doenças cardiometabólicas", range: [0.88, 1], color: "#d30202" },
            ],
        },
        {
            idadeMin: 50,
            idadeMax: 59,
            faixas: [
                { name: "Risco baixo para desenvolver doenças cardiometabólicas", range: [0, 0.74], color: "#00c457" },
                { name: "Risco moderado para desenvolver doenças cardiometabólicas", range: [0.74, 0.81], color: "#ffbb28" },
                { name: "Risco alto para desenvolver doenças cardiometabólicas", range: [0.82, 0.88], color: "#ff8042" },
                { name: "Risco muito alto para desenvolver doenças cardiometabólicas", range: [0.89, 1], color: "#d30202" },
            ],
        },
        {
            idadeMin: 60,
            idadeMax: 100,
            faixas: [
                { name: "Risco baixo para desenvolver doenças cardiometabólicas", range: [0, 0.76], color: "#00c457" },
                { name: "Risco moderado para desenvolver doenças cardiometabólicas", range: [0.76, 0.83], color: "#ffbb28" },
                { name: "Risco alto para desenvolver doenças cardiometabólicas", range: [0.84, 0.90], color: "#ff8042" },
                { name: "Risco muito alto para desenvolver doenças cardiometabólicas", range: [0.91, 1], color: "#d30202" },
            ],
        },
    ];

    const getFaixasIRCQ = (idade, sexo) => {
        if (sexo === "Masculino") {
            const grupo = faixasRCQPorIdadeHomem.find(
                (g) => idade >= g.idadeMin && idade <= g.idadeMax
            );
            return grupo ? grupo.faixas : [];
        }
        else {
            const grupo = faixasRCQPorIdadeMulheres.find(
                (g) => idade >= g.idadeMin && idade <= g.idadeMax
            );
            return grupo ? grupo.faixas : [];
        }

    };

    const faixasIRCQcalculadas = getFaixasIRCQ(idade, sexo);

    const calculaIRCQ = () => {
        const valorIRCQ = formatarNumero((cintura / quadril), 2);
        setIRCQ(valorIRCQ);
    }

    // ---------- ICA ---------- 
    const faixasICA = [
        { name: "Adiposidade central saudável", range: [0.05, 0.5], color: "#00c457" },
        { name: "Adiposidade central elevada", range: [0.5, 0.6], color: "#ffbb28" },
        { name: "Adiposidade central alta", range: [0.6, 1.8], color: "#fb1d1d" },
    ];

    const calculaICA = () => {
        const valorICA = formatarNumero((cintura / altura), 2);
        setICA(valorICA);
    }

    // ---------- IAC ---------- 
    const faixasIACHomens = [
        { name: "Índice de adiposidade normal", range: [8, 20], color: "#00c457" },
        { name: "Índice de adiposidade para sobrepeso", range: [21, 25], color: "#ffbb28" },
        { name: "Índice de adiposidade para obesidade", range: [26, 100], color: "#fb1d1d" }, // 100 como limite alto simbólico
    ];

    const faixasIACMulheres = [
        { name: "Índice de adiposidade normal", range: [21, 32], color: "#00c457" },
        { name: "Índice de adiposidade para sobrepeso", range: [33, 38], color: "#ffbb28" },
        { name: "Índice de adiposidade para obesidade", range: [39, 100], color: "#fb1d1d" },
    ];

    const getFaixasIAC = (sexo) => {
        if (sexo === "Masculino") {
            return faixasIACHomens;
        }
        else {
            return faixasIACMulheres;
        }
    };

    const faixasIACcalculadas = getFaixasIAC(sexo);

    const calculaIAC = () => {
        getFaixasIAC();
        const valorIAC = formatarNumero((((quadril) / ((altura / 100) * (Math.sqrt(altura / 100)))) - 18), 2);
        return setIAC(valorIAC);
    }

    // ---------- Conicidade ---------- 
    const faixasConicidade = [
        { name: "Bicôncavo. Baixo risco para desenvolver doenças cardiometabólicas.", range: [0, 0.95], color: "#ffbb28" },
        { name: "Cilíndrico. Baixo risco para desenvolver doenças cardiometabólicas.", range: [0.96, 1.05], color: "#00c457" },
        { name: "Bicônico. Alto risco para desenvolver doenças cardiometabólicas.", range: [1.05, 3], color: "#fb1d1d" },
    ];

    const calcularConicidade = () => {
        const alturaEmMetros = parseFloat(altura) / 100;
        const cinturaEmMetros = parseFloat(cintura) / 100;
        const con = formatarNumero((cinturaEmMetros / (0.109 * Math.sqrt(peso / alturaEmMetros))), 2);
        setConicidade(con);
    };

    const metaConicidade = () => {
        if (conicidade < 0.95) {
            let dif = 1 - conicidade;
            return "A circunferência da cintura é " + formatarNumero((dif * 100), 0) + "% menor que a nota de corte.";
        }
        else if (conicidade > 1.05) {
            let dif = conicidade - 1;
            return "A circunferência da cintura é " + formatarNumero((dif * 100), 0) + "% maior que a nota de corte.";
        } else {
            return "A circunferência da cintura está dentro dos padrões de normalidade.";
        }
    }

    // ---------- Peso ideal ---------- 
    const [faixasPI, setFaixasPI] = useState('');

    const calcularFaixasPesoIdeal = () => {
        const alturaAoQuadrado = altura / 100 * altura / 100; // Em metros

        // Faixas do IMC ideal
        const limiteInferior = alturaAoQuadrado * 18.5;
        const limiteSuperior = alturaAoQuadrado * 24.9;

        const faixasPI = [
            {
                name: "Abaixo do limite inferior",
                range: [0, Number(formatarNumero(limiteInferior, 2))],
                color: "#ffbb28",
            },
            {
                name: "Dentro da faixa ideal",
                range: [Number(formatarNumero(limiteInferior, 2)), Number(formatarNumero(limiteSuperior, 2))],
                color: "#00c457",
            },
            {
                name: "Acima do limite superior",
                range: [
                    Number(formatarNumero(limiteSuperior, 2)),
                    Number(250),
                ],
                color: "#fb1d1d",
            },
        ];

        setFaixasPI(faixasPI);
    }

    const metaPesoIdeal = () => {
        if (peso < faixasPI[1].range[0]) {
            let dif = faixasPI[1].range[0] - peso;
            return "Você deve ganhar " + formatarNumero(dif, 2) + "kg para alcançar a faixa ideal.";
        }
        else if (peso > faixasPI[1].range[1]) {
            let dif = peso - faixasPI[1].range[1];
            return "Você deve perder " + formatarNumero(dif, 2) + "kg para alcançar a faixa ideal.";
        }
    }

    const calculaPesoIdeal = () => {
        let pesoNormal = (altura / 100) * (altura / 100);
        let pi = formatarNumero((pesoNormal * 21.7), 2);

        setPesoIdeal(pi);
        calcularFaixasPesoIdeal();
    }

    // ---------- TMB ---------- 
    const calculaTMB = () => {
        let tmb;

        if (sexo === "Masculino") {
            tmb = (10 * peso) + (6.25 * altura) - (5 * idade) + 5;
        } else {
            tmb = (10 * peso) + (6.25 * altura) - (5 * idade) - 161;
        }

        setTMB(tmb);

        calculaTMD(tmb);
        calculaGET(tmb);
    };

    // ---------- TMD ---------- 
    const calculaTMD = (tmbAtual) => {
        let tmd, fator;
        if (fatorAtividade === 'sedentario') {
            fator = 1.2;
        } else if (fatorAtividade === 'leve') {
            fator = 1.375;
        } else if (fatorAtividade === 'moderada') {
            fator = 1.55;
        } else if (fatorAtividade === 'alta') {
            fator = 1.725;
        } else {
            fator = 1.9;
        }

        tmd = fator * tmbAtual;

        return tmd;
    };

    // ---------- GET ---------- 
    const [faixasGET, setFaixasGET] = useState([
        { name: "Taxa metabólica basal (TMB)", value: 0, color: "#ffbb28" },
        { name: "Gasto energético com atividade física (GEAF)", value: 0, color: "#0088fe" },
        { name: "Efeito térmico da alimentação (ETA)", value: 0, color: "#00c49f" },
    ]);

    const calculaGET = (tmbAtual) => {
        const get = calculaTMD(tmbAtual);
        const eta = get * 0.1;
        const geaf = get - tmbAtual - eta;

        setGET(get);

        // atualiza o array de faixas:
        setFaixasGET([
            { name: "Taxa metabólica basal (TMB)", value: tmbAtual, color: "#ffbb28" },
            { name: "Gasto energético com atividade física (GEAF)", value: geaf, color: "#0088fe" },
            { name: "Efeito térmico da alimentação (ETA)", value: eta, color: "#00c49f" },
        ]);
    };

    // Chama a execução das funções quando alterar os valores
    useEffect(() => {
        calcularIMC();
        calculaPesoIdeal();
        calculaTMB();
        calcularConicidade();
        calculaICA();
        calculaIAC();
    }, [cintura, peso, altura,]);

    useEffect(() => {
        calculaTMB();
    }, [fatorAtividade]);

    useEffect(() => {
        calculaIRCQ();
        calculaICA();
        calculaIAC();
        calcularConicidade();
    }, [cintura, abdomen, quadril]);

    useEffect(() => {
        trocaImagemAnatomia();
    }, []);


    useEffect(() => {
        if (evaluationData?.antropometria) {
            const a = evaluationData.antropometria;
            if (a.peso) setPeso(a.peso);
            if (a.idade) setIdade(a.idade);
            if (a.altura) setAltura(a.altura);
            if (a.sexo) setSexo(a.sexo);
            if (a.fatorAtividade) setFatorAtividade(a.fatorAtividade);
            if (a.pescoço) setPescoço(a.pescoço);
            if (a.ombro) setOmbro(a.ombro);
            if (a.toraxNormal) setToraxNormal(a.toraxNormal);
            if (a.toraxInspirado) setToraxInspirado(a.toraxInspirado);
            if (a.abdomen) setAbdomen(a.abdomen);
            if (a.cintura) setCintura(a.cintura);
            if (a.quadril) setQuadril(a.quadril);
            if (a.coxaDproximal) setCoxaDproximal(a.coxaDproximal);
            if (a.coxaEproximal) setCoxaEproximal(a.coxaEproximal);
            if (a.coxaDmedial) setCoxaDmedial(a.coxaDmedial);
            if (a.coxaEmedial) setCoxaEmedial(a.coxaEmedial);
            if (a.pernaD) setPernaD(a.pernaD);
            if (a.pernaE) setPernaE(a.pernaE);
            if (a.bracoDrelaxado) setBracoDrelaxado(a.bracoDrelaxado);
            if (a.bracoErelaxado) setBracoErelaxado(a.bracoErelaxado);
            if (a.bracoDcontraido) setBracoDcontraido(a.bracoDcontraido);
            if (a.bracoEcontraido) setBracoEcontraido(a.bracoEcontraido);
            if (a.antebracoD) setAntebracoD(a.antebracoD);
            if (a.antebracoE) setAntebracoE(a.antebracoE);
            if (a.punhoD) setPunhoD(a.punhoD);
            if (a.punhoE) setPunhoE(a.punhoE);
        }
    }, [evaluationData]);

    const handleAntropometriaRegister = async () => {
        const payload = {
            antropometria: {
                peso, idade, altura, sexo, fatorAtividade,
                pescoço, ombro, toraxNormal, toraxInspirado,
                abdomen, cintura, quadril,
                coxaDproximal, coxaEproximal, coxaDmedial, coxaEmedial,
                pernaD, pernaE,
                bracoDrelaxado, bracoErelaxado, bracoDcontraido, bracoEcontraido,
                antebracoD, antebracoE, punhoD, punhoE,
                imc, IRCQ, ICA, IAC, conicidade, pesoIdeal, TMB, GET
            },
            evaluationId
        };

        try {
            const response = await api.post(`/api/student/${aluno.id}/evaluation/antropometria`, payload, { withCredentials: true });
            if (response.status === 200) {
                if (response.data.evaluationId && setEvaluationId) {
                    if (!evaluationId) {
                        if (!aluno.avaliacoesRealizadas) aluno.avaliacoesRealizadas = [];
                        aluno.avaliacoesRealizadas.push({
                            id: response.data.evaluationId,
                            data: new Date().toISOString()
                        });
                    }
                    setEvaluationId(response.data.evaluationId);
                }
                if (updateEvaluationData) {
                    updateEvaluationData({ antropometria: payload.antropometria });
                }
                openNextModal();
            }
        } catch (error) {
            console.error('Erro ao salvar Antropometria:', error);
        }
    };

    // Navegação provisória
    const toComposicaoCorporal = () => {
        setActiveTab("Composicao Corporal");
    };

    return (
        <div className="avaliacao-container">
            <div className="avaliacao-content">
                {etapa === 1 && (
                    <div className="questions-container">
                        <div className="questions-66 perimetro-left">
                            <div className="question-item">
                                <div className="standard-title">Peso e estatura</div>
                                <div className="answer-container entrada-peso-altura">
                                    <div className="answer-item pad-right-10">
                                        <p className="answer-title">Peso em kilos:</p>
                                        <input className="input-size-30" type="number" name="peso" autoComplete="off" placeholder={peso} value={peso} onChange={e => setPeso(e.target.value)} />
                                        <p className="answer-title">Kg</p>
                                    </div>
                                    <div className="answer-item">
                                        <p className="answer-title">Altura em centímetros:</p>
                                        <input className="input-size-30" type="number" name="altura" autoComplete="off" placeholder={altura} value={altura} onChange={e => setAltura(e.target.value)} />
                                        <p className="answer-title">Cm</p>
                                    </div>
                                </div>
                            </div>

                            <div className="standard-title margin-top-20">Perímetros corporais</div>
                            <div class="colunas-perimetro">
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Pescoço:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="pescoço" autoComplete="off" placeholder={pescoço} value={pescoço} onFocus={() => moverFitaPorItem(sexo, "Pescoço")} onChange={e => setPescoço(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoPescoço(true)} onMouseLeave={() => setShowInfoPescoço(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoPescoço && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: na parte superior da proeminência da laringe (pomo de adão); (Kevin Norton) <br />
                                                        • Procedimento: com a mínima pressão sobre a pele, mede-se o perímetro mantendo a fita em ângulo reto com relação ao eixo longitudinal do pescoço.<br />
                                                        •	OBS: Estudos realizados no Brasil indicaram pontos de corte variando de 39,5 cm a 39,6 cm para homens e 33,3 cm a 36,1 cm para mulheres para predição de risco cardiometabólico.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Ombro:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="ombro" autoComplete="off" placeholder={ombro} value={ombro} onFocus={() => moverFitaPorItem(sexo, "Ombro")} onChange={e => setOmbro(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoOmbro(true)} onMouseLeave={() => setShowInfoOmbro(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoOmbro && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: maior perímetro da região dos ombros, envolvendo ambos os braços;<br />
                                                        • Procedimento: passa-se a fita métrica em torno dos ombros e parte superior dos braços, com o avaliado em pé, braços relaxados ao longo do corpo. A fita deve estar ajustada, sem compressão, e nivelada no plano horizontal.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Tórax normal:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="toraxNormal" autoComplete="off" placeholder={toraxNormal} value={toraxNormal} onFocus={() => moverFitaPorItem(sexo, "Torax")} onChange={e => setToraxNormal(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoToraxNormal(true)} onMouseLeave={() => setShowInfoToraxNormal(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoToraxNormal && (
                                                <div className="info-box-content" style={{ transform: 'translateX(-385px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: para homens adota-se a linha dos mamilos como referência. Para as mulheres, a
                                                        medida deve ser feita logo acima das mamas, para evitar a influência das mesmas.<br />
                                                        • Procedimento: passar a fita em torno do avaliado tendo cuidado para manter a mesma no plano horizontal.
                                                        Fazer a leitura após expiração normal.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Tórax inspirado:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="toraxInspirado" autoComplete="off" placeholder={toraxInspirado} value={toraxInspirado} onFocus={() => moverFitaPorItem(sexo, "Torax")} onChange={e => setToraxInspirado(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoToraxInspirado(true)} onMouseLeave={() => setShowInfoToraxInspirado(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoToraxInspirado && (
                                                <div className="info-box-content" style={{ transform: 'translateX(-385px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: para homens adotase a linha dos mamilos como referência. Para as mulheres, a
                                                        medida deve ser feita logo acima das mamas, para evitar a influência das mesmas.<br />
                                                        • Procedimento: passar a fita em torno do avaliado tendo cuidado para manter a mesma no plano horizontal.
                                                        Fazer a leitura após expiração normal.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="colunas-perimetro">
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Cintura:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="cintura" autoComplete="off" placeholder={cintura} value={cintura} onFocus={() => moverFitaPorItem(sexo, "Cintura")} onChange={e => setCintura(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoCintura(true)} onMouseLeave={() => setShowInfoCintura(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoCintura && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: região abdominal em seu menor perímetro;<br />
                                                        • Procedimento: passa-se a fita em torno do avaliado, procurando sua menor circunferência, tendo cuidado
                                                        para mantê-la no plano horizontal. Faz-se a leitura após expiração normal
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Abdômen:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="abdomen" autoComplete="off" placeholder={abdomen} value={abdomen} onFocus={() => moverFitaPorItem(sexo, "Abdomen")} onChange={e => setAbdomen(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoAbdomen(true)} onMouseLeave={() => setShowInfoAbdomen(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoAbdomen && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: cicatriz umbilical.<br />
                                                        • Procedimento: passa-se a fita em torno do avaliado, tendo como referência a cicatriz umbilical, tendo
                                                        cuidado para mantêla no plano horizontal.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Quadril:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="quadril" autoComplete="off" placeholder={quadril} value={quadril} onFocus={() => moverFitaPorItem(sexo, "Quadril")} onChange={e => setQuadril(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoQuadril(true)} onMouseLeave={() => setShowInfoQuadril(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoQuadril && (
                                                <div className="info-box-content" style={{ transform: 'translateX(-385px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: maior porção da região glútea (nádegas). Normalmente esse ponto é localizado na
                                                        altura da dobra inguinal.<br />
                                                        • Procedimento: faz-se a mensuração no maior perímetro do quadril. Pontos anatômicos
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">

                                </div>
                            </div>

                            <div class="colunas-perimetro">
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Coxa D Proximal:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="coxaDproximal" autoComplete="off" placeholder={coxaDproximal} value={coxaDproximal} onFocus={() => moverFitaPorItem(sexo, "CoxaProximalD")} onChange={e => setCoxaDproximal(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoCoxaDP(true)} onMouseLeave={() => setShowInfoCoxaDP(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoCoxaDP && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: 1 cm abaixo da prega glútea;<br />
                                                        • Procedimento: localiza-se a prega glútea, aloja-se a fita na porção da coxa mais próxima da prega e faz-se a
                                                        medida na face lateral da coxa.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Coxa D Medial:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="coxaDmedial" autoComplete="off" placeholder={coxaDmedial} value={coxaDmedial} onFocus={() => moverFitaPorItem(sexo, "CoxaMedialD")} onChange={e => setCoxaDmedial(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoCoxaDM(true)} onMouseLeave={() => setShowInfoCoxaDM(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoCoxaDM && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: ponto médio entre a dobra inguinal e a borda proximal da patela em extensão do
                                                        joelho;<br />
                                                        • Procedimento: Com o indivíduo em pé e com o peso distribuído igualmente nas duas pernas ligeiramente
                                                        afastadas, passar a fita em torno da referência marcada.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Coxa E Proximal:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="coxaEproximal" autoComplete="off" placeholder={coxaEproximal} value={coxaEproximal} onFocus={() => moverFitaPorItem(sexo, "CoxaProximalE")} onChange={e => setCoxaEproximal(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoCoxaEP(true)} onMouseLeave={() => setShowInfoCoxaEP(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoCoxaEP && (
                                                <div className="info-box-content" style={{ transform: 'translateX(-385px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: 1 cm abaixo da prega glútea;<br />
                                                        • Procedimento: localiza-se a prega glútea, aloja-se a fita na porção da coxa mais próxima da prega e faz-se a
                                                        medida na face lateral da coxa.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Coxa E medial:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="coxaEmedial" autoComplete="off" placeholder={coxaEmedial} value={coxaEmedial} onFocus={() => moverFitaPorItem(sexo, "CoxaMedialE")} onChange={e => setCoxaEmedial(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoCoxaEM(true)} onMouseLeave={() => setShowInfoCoxaEM(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoCoxaEM && (
                                                <div className="info-box-content" style={{ transform: 'translateX(-385px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: ponto médio entre a dobra inguinal e a borda proximal da patela em extensão do
                                                        joelho;<br />
                                                        • Procedimento: Com o indivíduo em pé e com o peso distribuído igualmente nas duas pernas ligeiramente
                                                        afastadas, passar a fita em torno da referência marcada.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="colunas-perimetro">
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Perna D:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="pernaD" autoComplete="off" placeholder={pernaD} value={pernaD} onFocus={() => moverFitaPorItem(sexo, "PernaD")} onChange={e => setPernaD(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoPernaD(true)} onMouseLeave={() => setShowInfoPernaD(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoPernaD && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: região da panturrilha em seu maior perímetro;<br />
                                                        • Procedimento: move-se a fita métrica em torno e ao longo da panturrilha para achar o ponto de maior
                                                        perímetro. A leitura deve ser feita com o indivíduo sentado, com a perna flexionada em 90° e com a fita métrica
                                                        paralela ao chão.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Perna E:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="pernaE" autoComplete="off" placeholder={pernaE} value={pernaE} onFocus={() => moverFitaPorItem(sexo, "PernaE")} onChange={e => setPernaE(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoPernaE(true)} onMouseLeave={() => setShowInfoPernaE(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoPernaE && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: região da panturrilha em seu maior perímetro;<br />
                                                        • Procedimento: move-se a fita métrica em torno e ao longo da panturrilha para achar o ponto de maior
                                                        perímetro. A leitura deve ser feita com o indivíduo sentado, com a perna flexionada em 90° e com a fita métrica
                                                        paralela ao chão.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">

                                </div>
                                <div class="coluna-perimetro-185">

                                </div>
                            </div>

                            <div class="colunas-perimetro">
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Braço D relaxado:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="bracoDrelaxado" autoComplete="off" placeholder={bracoDrelaxado} value={bracoDrelaxado} onFocus={() => moverFitaPorItem(sexo, "BraçoRelaxadoD")} onChange={e => setBracoDrelaxado(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoBracoDR(true)} onMouseLeave={() => setShowInfoBracoDR(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoBracoDR && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: ponto médio entre o acrômio e a articulação úmero-radial;<br />
                                                        • Procedimento: o braço deve estar estendido ao longo do corpo e relaxado, deve-se envolver o braço com a
                                                        fita perpendicularmente ao eixo longitudinal do úmero.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Braço D contraido:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="bracoDcontraido" autoComplete="off" placeholder={bracoDcontraido} value={bracoDcontraido} onFocus={() => moverFitaPorItem(sexo, "BraçoContraidoD")} onChange={e => setBracoDcontraido(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoBracoDC(true)} onMouseLeave={() => setShowInfoBracoDC(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoBracoDC && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: maior perímetro do braço direito;<br />
                                                        • Procedimento: com o braço flexionado a frente do corpo, em um ângulo de aproximadamente 45º, achar o
                                                        ponto anatômico. Passar a fita, enquanto o individuo mantém o braço relaxado. Com a fita posicionada,
                                                        orientar o avaliado a contrair o braço com ajuda da mão esquerda, enquanto a medição é realizada
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Braço E relaxado:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="bracoErelaxado" autoComplete="off" placeholder={bracoErelaxado} value={bracoErelaxado} onFocus={() => moverFitaPorItem(sexo, "BraçoRelaxadoE")} onChange={e => setBracoErelaxado(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoBracoER(true)} onMouseLeave={() => setShowInfoBracoER(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoBracoER && (
                                                <div className="info-box-content" style={{ transform: 'translateX(-385px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: ponto médio entre o acrômio e a articulação úmero-radial;<br />
                                                        • Procedimento: o braço deve estar estendido ao longo do corpo e relaxado, deve-se envolver o braço com a
                                                        fita perpendicularmente ao eixo longitudinal do úmero.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Braço E contraido:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="bracoEcontraido" autoComplete="off" placeholder={bracoEcontraido} value={bracoEcontraido} onFocus={() => moverFitaPorItem(sexo, "BraçoContraidoE")} onChange={e => setBracoEcontraido(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoBracoEC(true)} onMouseLeave={() => setShowInfoBracoEC(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoBracoEC && (
                                                <div className="info-box-content" style={{ transform: 'translateX(-385px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: maior perímetro do braço direito;<br />
                                                        • Procedimento: com o braço flexionado a frente do corpo, em um ângulo de aproximadamente 45º, achar o
                                                        ponto anatômico. Passar a fita, enquanto o individuo mantém o braço relaxado. Com a fita posicionada,
                                                        orientar o avaliado a contrair o braço com ajuda da mão esquerda, enquanto a medição é realizada
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="colunas-perimetro">
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Antebraço D:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="antebracoD" autoComplete="off" placeholder={antebracoD} value={antebracoD} onFocus={() => moverFitaPorItem(sexo, "AntebraçoD")} onChange={e => setAntebracoD(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoAntebracoD(true)} onMouseLeave={() => setShowInfoAntebracoD(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoAntebracoD && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: é o maior perímetro do antebraço direito;<br />
                                                        • Procedimento: o individuo deve estar com o braço levemente estendido a frente do corpo com a mão na
                                                        posição anatômica. O avaliador deve mover a fita em torno do antebraço a fim de localizar o ponto de maior
                                                        perímetro.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Punho D:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="punhoD" autoComplete="off" placeholder={punhoD} value={punhoD} onFocus={() => moverFitaPorItem(sexo, "PunhoD")} onChange={e => setPunhoD(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoPunhoD(true)} onMouseLeave={() => setShowInfoPunhoD(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoPunhoD && (
                                                <div className="info-box-content" style={{ transform: 'translateX(220px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: região imediatamente após os processos estilóides do rádio e da ulna;<br />
                                                        • Procedimento: o indivíduo deve estar com a palma da mão voltada para cima, enquanto passa-se a fita de
                                                        baixo para cima conforme a referência anatômica.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Antebraço E:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="antebracoE" autoComplete="off" placeholder={antebracoE} value={antebracoE} onFocus={() => moverFitaPorItem(sexo, "AntebraçoE")} onChange={e => setAntebracoE(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoAntebracoE(true)} onMouseLeave={() => setShowInfoAntebracoE(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoAntebracoE && (
                                                <div className="info-box-content" style={{ transform: 'translateX(-385px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: é o maior perímetro do antebraço direito;<br />
                                                        • Procedimento: o individuo deve estar com o braço levemente estendido a frente do corpo com a mão na
                                                        posição anatômica. O avaliador deve mover a fita em torno do antebraço a fim de localizar o ponto de maior
                                                        perímetro.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div class="coluna-perimetro-185">
                                    <div className='entrada-perimetros'>
                                        <p class="perg-perimetros">Punho E:</p>
                                        <input className="entrada-texto-perimetros" type="number" name="punhoE" autoComplete="off" placeholder={punhoE} value={punhoE} onFocus={() => moverFitaPorItem(sexo, "PunhoE")} onChange={e => setPunhoE(e.target.value)} />
                                        <div className="info-box-container" onMouseEnter={() => setShowInfoPunhoE(true)} onMouseLeave={() => setShowInfoPunhoE(false)}>
                                            <div className="info-icon">
                                                <Search className="info-icon-perimetros-styles" size={17} style={{ marginLeft: '5px' }} />
                                            </div>
                                            {showInfoPunhoE && (
                                                <div className="info-box-content" style={{ transform: 'translateX(-385px) translateY(100px)' }}>
                                                    <p className="">
                                                        • Localização do ponto: região imediatamente após os processos estilóides do rádio e da ulna;<br />
                                                        • Procedimento: o indivíduo deve estar com a palma da mão voltada para cima, enquanto passa-se a fita de
                                                        baixo para cima conforme a referência anatômica.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="questions-33 perimetro-right max-height-500px">
                            <div className='body-img-container'>
                                <img className="body-img" src={imagemAnatomia} alt="Anatomia humana" />
                                <img ref={fitaRef} className="fita-img" src={FitaMetrica} alt="Fita métrica" style={{ opacity: fitaVisivel ? 1 : 0 }} />
                                {showInfoLegendaCorpo === "Pescoço" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Na parte superior da proeminência da laringe.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "Ombro" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Maior perímetro da região dos ombros, envolvendo ambos os braços.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "Torax" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text info-torax">
                                            <b>Homens:</b> Adota-se a linha dos mamilos como referência.<br /><br /> <b>Mulheres:</b> A medida deve ser feita logo acima das mamas, para evitar a influência das mesmas.
                                        </span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "Cintura" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Região abdominal em seu menor perímetro.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "Abdomen" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Cicatriz umbilical.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "Quadril" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Maior porção da região glútea. Normalmente esse ponto é localizado na altura da dobra inguinal.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "CoxaProximal" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">1 cm abaixo da prega glútea.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "CoxaMedial" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Ponto médio entre a dobra inguinal e a borda proximal da patela em extensão do joelho.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "Perna" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Região da panturrilha em seu maior perímetro.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "BraçoRelaxado" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Ponto médio entre o acrômio e a articulação úmero-radial.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "BraçoContraido" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Com o braço flexionado à frente do corpo, em um ângulo de aproximadamente 90º, maior perímetro do braço.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "Antebraço" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Maior perímetro do antebraço.</span>
                                    </p>
                                )}
                                {showInfoLegendaCorpo === "Punho" && (
                                    <p className="body-legenda">
                                        <span className="img-legenda-title">Localização da medida:</span>
                                        <span className="img-legenda-text">Região imediatamente após os processos estilóides do rádio e da ulna.</span>
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {etapa === 2 && (
                    <div className="questions-container">
                        <div className="questions-33 border-right pad-right-20 max-height-500px">
                            <div className="standard-title">
                                Índice de massa corporal (IMC)
                                <div className="info-box-container" onMouseEnter={() => setShowInfoIMC(true)} onMouseLeave={() => setShowInfoIMC(false)}>
                                    <div className="info-icon">
                                        <HelpCircle className="info-icon-title" size={20} style={{ marginLeft: '5px' }} />
                                    </div>
                                    {showInfoIMC && (
                                        <div className="info-box-content" style={{ transform: 'translateX(-138px) translateY(195px)' }}>
                                            <p className="">
                                                O IMC é um dos indicadores mais utilizados para a classificação do estado nutricional. É calculado pela relação entre
                                                o peso e a altura (kg/m²), permitindo identificar se o indivíduo está com baixo peso, peso adequado, sobrepeso ou obesidade.
                                                Apesar de sua ampla aplicação, não distingue massa magra de gordura corporal.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p class="antropometria-result">IMC Calculado: {imc} Kg/m²</p>
                            <GraficoBarraComIndicador valor={imc} faixas={faixasIMC} />
                            {encontrarFaixa(imc, faixasIMC) && (
                                <div
                                    className="resultado-classificacao"
                                    style={{ border: `2px solid ${encontrarFaixa(imc, faixasIMC)?.color}`, }}>
                                    <span>
                                        Classificação: <strong>{encontrarFaixa(imc, faixasIMC)?.name}</strong>
                                    </span>
                                </div>
                            )}
                            <div className="legend pad-top-10">
                                {faixasIMC.map((item, index) => {
                                    let label = "";

                                    if (index === 0) {
                                        label = `Abaixo de ${item.range[1]} Kg/m²`;
                                    } else if (index === faixasIMC.length - 1) {
                                        label = `Acima de ${item.range[0]} Kg/m²`;
                                    } else {
                                        label = `De ${item.range[0]} Kg/m² a ${item.range[1]}  Kg/m²`;
                                    }

                                    return (
                                        <div key={index} className="legend-item">
                                            <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                                            {label}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="questions-33 border-right pad-right-20 max-height-500px">
                            <div className="standard-title">
                                Medida da circunferência Abdominal
                                <div className="info-box-container" onMouseEnter={() => setShowInfoCircunferenciaAbdominal(true)} onMouseLeave={() => setShowInfoCircunferenciaAbdominal(false)}>
                                    <div className="info-icon">
                                        <HelpCircle className="info-icon-title" size={20} style={{ marginLeft: '5px' }} />
                                    </div>
                                    {showInfoCircunferenciaAbdominal && (
                                        <div className="info-box-content" style={{ transform: 'translateX(-138px) translateY(195px)' }}>
                                            <p className="">
                                                A circunferência abdominal é uma medida simples e eficaz para avaliar o acúmulo de gordura na região central do corpo. Valores elevados estão
                                                diretamente associados a um maior risco de desenvolvimento de doenças cardiometabólicas, como diabetes tipo 2, hipertensão e dislipidemias. Os
                                                pontos de corte variam de acordo com o sexo.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p class="antropometria-result">Medida: {abdomen} Cm</p>
                            <GraficoBarraComIndicador valor={abdomen} faixas={faixasAbdomen} />
                            {encontrarFaixa(abdomen, faixasAbdomen) && (
                                <div
                                    className="resultado-classificacao"
                                    style={{ border: `2px solid ${encontrarFaixa(abdomen, faixasAbdomen)?.color}`, }}>
                                    <span>
                                        Classificação: <strong>{encontrarFaixa(abdomen, faixasAbdomen)?.name}</strong>
                                    </span>
                                </div>
                            )}
                            <div className="legend pad-top-10">
                                {faixasAbdomen.map((item, index) => {
                                    let label = "";

                                    if (index === 0) {
                                        label = `Abaixo de ${item.range[1]} Cm`;
                                    } else if (index === faixasAbdomen.length - 1) {
                                        label = `Acima de ${item.range[0]} Cm`;
                                    } else {
                                        label = `De ${item.range[0]} Cm a ${item.range[1]}  Cm`;
                                    }

                                    return (
                                        <div key={index} className="legend-item">
                                            <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                                            {label}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="questions-33 max-height-500px">
                            <div className="standard-title">
                                Índice relação Cintura - Quadril (IRCQ)
                                <div className="info-box-container" onMouseEnter={() => setShowInfoIRCQ(true)} onMouseLeave={() => setShowInfoIRCQ(false)}>
                                    <div className="info-icon">
                                        <HelpCircle className="info-icon-title" size={20} style={{ marginLeft: '5px' }} />
                                    </div>
                                    {showInfoIRCQ && (
                                        <div className="info-box-content" style={{ transform: 'translateX(-350px) translateY(205px)' }}>
                                            <p className="">
                                                O IRCQ avalia a distribuição de gordura corporal e está associada ao risco cardiovascular. Valores elevados
                                                indicam maior acúmulo de gordura abdominal, fator de risco para doenças como hipertensão, diabetes e
                                                doenças cardíacas. Os pontos de corte variam conforme o sexo.
                                            </p>
                                            <p className="info-box-ref">
                                                (Adaptado de Bray and Gray, 1988b,p. 432)
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p class="antropometria-result">IRCQ: {IRCQ}</p>
                            <GraficoBarraComIndicador valor={IRCQ} faixas={faixasIRCQcalculadas} />
                            {encontrarFaixa(IRCQ, faixasIRCQcalculadas) && (
                                <div
                                    className="resultado-classificacao"
                                    style={{ border: `2px solid ${encontrarFaixa(IRCQ, faixasIRCQcalculadas)?.color}`, }}>
                                    <span>
                                        Classificação: <strong>{encontrarFaixa(IRCQ, faixasIRCQcalculadas)?.name}</strong>
                                    </span>
                                </div>
                            )}
                            <div className="legend pad-top-20">
                                {faixasIRCQcalculadas.map((item, index) => {
                                    let label = "";

                                    if (index === 0) {
                                        label = `Abaixo de ${item.range[1]} Kg/m²`;
                                    } else if (index === faixasIRCQcalculadas.length - 1) {
                                        label = `Acima de ${item.range[0]} Kg/m²`;
                                    } else {
                                        label = `De ${item.range[0]} Kg/m² a ${item.range[1]}  Kg/m²`;
                                    }

                                    return (
                                        <div key={index} className="legend-item">
                                            <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                                            {label}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}

                {etapa === 3 && (
                    <div className="questions-container">
                        <div className="questions-33 border-right pad-right-20 max-height-500px">
                            <div className="standard-title">
                                Índice Cintura - Altura (ICA)
                                <div className="info-box-container" onMouseEnter={() => setShowInfoICA(true)} onMouseLeave={() => setShowInfoICA(false)}>
                                    <div className="info-icon">
                                        <HelpCircle className="info-icon-title" size={20} style={{ marginLeft: '5px' }} />
                                    </div>
                                    {showInfoICA && (
                                        <div className="info-box-content" style={{ transform: 'translateX(-138px) translateY(310px)' }}>
                                            <p className="">
                                                O ICA é um índice antropométrico fortemente associado a diversos fatores de risco cardiovascular como
                                                dislipidemias e diabetes, sendo melhor preditor de risco do que o IMC e o PC (peso corporal) isoladamente.
                                                O ponto de corte de 0,5 é o valor mais indicado independente do gênero, idade e etnia, sugerindo que o PC
                                                deve ser menor que a metade da medida de estatura. O ICA possui relação direta com o crescimento,
                                                justificando um único valor para os pontos de corte independentemente da idade
                                            </p>
                                            <p className="info-box-ref">
                                                Obesity: identification, assessment and management. London: National Institute for
                                                Health and Care Excellence (NICE); 2023 Jul 26. (NICE Guideline, No. 189.)
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p class="antropometria-result">ICA: {ICA}</p>
                            <GraficoBarraComIndicador valor={ICA} faixas={faixasICA} />
                            {encontrarFaixa(ICA, faixasICA) && (
                                <div
                                    className="resultado-classificacao"
                                    style={{ border: `2px solid ${encontrarFaixa(ICA, faixasICA)?.color}`, }}>
                                    <span>
                                        Classificação: <strong>{encontrarFaixa(ICA, faixasICA)?.name}</strong>
                                    </span>
                                </div>
                            )}
                            <div className="legend pad-top-10">
                                {faixasICA.map((item, index) => {
                                    let label = "";

                                    if (index === 0) {
                                        label = `Abaixo de ${item.range[1]}`;
                                    } else if (index === faixasICA.length - 1) {
                                        label = `Acima de ${item.range[0]}`;
                                    } else {
                                        label = `De ${item.range[0]} a ${item.range[1]} `;
                                    }

                                    return (
                                        <div key={index} className="legend-item">
                                            <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                                            {label}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="questions-33 border-right pad-right-20 max-height-500px">
                            <div className="standard-title">
                                Índice de adiposidade corporal (IAC)
                                <div className="info-box-container" onMouseEnter={() => setShowInfoIAC(true)} onMouseLeave={() => setShowInfoIAC(false)}>
                                    <div className="info-icon">
                                        <HelpCircle className="info-icon-title" size={20} style={{ marginLeft: '5px' }} />
                                    </div>
                                    {showInfoIAC && (
                                        <div className="info-box-content" style={{ transform: 'translateX(-138px) translateY(175px)' }}>
                                            <p className="">
                                                O IAC estima a porcentagem de gordura corporal utilizando medidas de estatura e circunferência do
                                                quadril. Diferente do IMC, ele oferece uma estimativa mais próxima da composição corporal real,
                                                especialmente em adultos, e é útil para complementar outras análises antropométricas.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p class="antropometria-result">IAC: {IAC}</p>
                            <GraficoBarraComIndicador valor={IAC} faixas={faixasIACcalculadas} />
                            {encontrarFaixa(IAC, faixasIACcalculadas) && (
                                <div
                                    className="resultado-classificacao"
                                    style={{ border: `2px solid ${encontrarFaixa(IAC, faixasIACcalculadas)?.color}`, }}>
                                    <span>
                                        Classificação: <strong>{encontrarFaixa(IAC, faixasIACcalculadas)?.name}</strong>
                                    </span>
                                </div>
                            )}
                            <div className="legend pad-top-10">
                                {faixasIACcalculadas.map((item, index) => {
                                    let label = "";

                                    if (index === 0) {
                                        label = `Abaixo de ${item.range[1]}`;
                                    } else if (index === faixasIACcalculadas.length - 1) {
                                        label = `Acima de ${item.range[0]}`;
                                    } else {
                                        label = `De ${item.range[0]} a ${item.range[1]} `;
                                    }

                                    return (
                                        <div key={index} className="legend-item">
                                            <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                                            {label}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="questions-33 max-height-500px">
                            <div className="standard-title">
                                Índice de conicidade
                                <div className="info-box-container" onMouseEnter={() => setShowInfoConicidade(true)} onMouseLeave={() => setShowInfoConicidade(false)}>
                                    <div className="info-icon">
                                        <HelpCircle className="info-icon-title" size={20} style={{ marginLeft: '5px' }} />
                                    </div>
                                    {showInfoConicidade && (
                                        <div className="info-box-content" style={{ transform: 'translateX(-350px) translateY(175px)' }}>
                                            <p className="">
                                                O IC avalia a forma do corpo e o acúmulo central de gordura, relacionando peso, altura e circunferência da
                                                cintura. Valores mais altos indicam maior concentração de gordura na região abdominal, associada a riscos
                                                metabólicos e cardiovasculares, mesmo em indivíduos com IMC normal.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p class="antropometria-result">Índice: {conicidade}</p>
                            <GraficoBarraComIndicador valor={conicidade} faixas={faixasConicidade} />
                            {encontrarFaixa(conicidade, faixasConicidade) && (
                                <div
                                    className="resultado-classificacao"
                                    style={{ border: `2px solid ${encontrarFaixa(conicidade, faixasConicidade)?.color}`, }}>
                                    <span>
                                        Classificação: <strong>{encontrarFaixa(conicidade, faixasConicidade)?.name}</strong>
                                    </span>
                                </div>
                            )}
                            <div>{metaConicidade()}</div>
                            <div className="conicidade-img-container pad-top-10">
                                <div className="legend">
                                    {faixasConicidade.map((item, index) => {
                                        let label = "";

                                        if (index === 0) {
                                            label = `Abaixo de ${item.range[1]}`;
                                        } else if (index === faixasConicidade.length - 1) {
                                            label = `Acima de ${item.range[0]}`;
                                        } else {
                                            label = `De ${item.range[0]} a ${item.range[1]} `;
                                        }

                                        return (
                                            <div key={index} className="legend-item">
                                                <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                                                {label}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="info-box-container" onMouseEnter={abrirImgConicidade} onMouseLeave={fecharImgConicidade}>
                                    <div className="info-button">
                                        Representação gráfica
                                    </div>
                                    {showImgConicidade && (
                                        <div
                                            className="info-box-content info-box-conicidade"
                                            onMouseEnter={abrirImgConicidade}
                                            onMouseLeave={fecharImgConicidade}
                                        >
                                            <img className="conicidade-img" src={ImagemConicidade} alt="Representação gráfica do índice de conicidade" />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {etapa === 4 && (
                    <div className="questions-container">
                        <div className="questions-33 border-right pad-right-20 max-height-500px">
                            <div className="standard-title">
                                Peso padrão de normalidade
                                <div className="info-box-container" onMouseEnter={() => setShowInfoPesoIdeal(true)} onMouseLeave={() => setShowInfoPesoIdeal(false)}>
                                    <div className="info-icon">
                                        <HelpCircle className="info-icon-title" size={20} style={{ marginLeft: '5px' }} />
                                    </div>
                                    {showInfoPesoIdeal && (
                                        <div className="info-box-content" style={{ transform: 'translateX(-138px) translateY(245px)' }}>
                                            <p className="">
                                                O peso padrão de normalidade é uma estimativa do peso corporal ideal baseado na altura do indivíduo. Serve como referência para avaliar se
                                                o peso atual está dentro de um intervalo considerado saudável, auxiliando na identificação de desvios como magreza ou excesso de peso. No
                                                entanto, não considera composição corporal, como proporção de músculos e gordura.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p class="antropometria-result antropometria-resultado-peso-ideal">Peso padrão de normalidade: {pesoIdeal} kg</p>
                            <p class="antropometria-result antropometria-resultado-peso-atual" style={{ marginTop: -20 }}>Peso atual: {peso} kg</p>
                        
                            <GraficoBarraComIndicador valor={peso} faixas={faixasPI} />
                            {encontrarFaixa(peso, faixasPI) && (
                                <div
                                    className="resultado-classificacao"
                                    style={{ border: `2px solid ${encontrarFaixa(peso, faixasPI)?.color}`, }}>
                                    <span>
                                        Classificação: <strong>{encontrarFaixa(peso, faixasPI)?.name}</strong>
                                    </span>
                                </div>
                            )}
                            <div>{metaPesoIdeal()}</div>
                            <div className="legend pad-top-10">
                                {faixasPI.map((item, index) => {
                                    let label = "";

                                    if (index === 0) {
                                        label = `Limite inferior do peso corporal estimado: ${item.range[1]} kg`;
                                    } else if (index === faixasPI.length - 1) {
                                        label = `Limite superior do peso corporal estimado: ${item.range[0]} kg`;
                                    } else {
                                        label = `Peso corporal padrão estimado: ${pesoIdeal} kg`;
                                    }

                                    return (
                                        <div key={index} className="legend-item">
                                            <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                                            {label}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="questions-33 border-right pad-right-20 max-height-500px">
                            <div className="standard-title">
                                Taxa Metabólica Basal (TMB)
                                <div className="info-box-container" onMouseEnter={() => setShowInfoTMB(true)} onMouseLeave={() => setShowInfoTMB(false)}>
                                    <div className="info-icon">
                                        <HelpCircle className="info-icon-title" size={20} style={{ marginLeft: '5px' }} />
                                    </div>
                                    {showInfoTMB && (
                                        <div className="info-box-content" style={{ transform: 'translateX(-138px) translateY(210px)' }}>
                                            <p className="">
                                                Taxa Metabólica Basal (TMB) é a quantidade mínima de energia (calorias) que o corpo gasta em repouso absoluto para manter funções vitais como
                                                respiração, circulação e temperatura corporal.
                                                <p className="info-box-ref">
                                                    Fórmula de Mifflin-St Jeor
                                                </p>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p class="antropometria-result">TMB: {TMB.toLocaleString('pt-BR', { maximumFractionDigits: 0 })} Kcal</p>

                            <div className="standard-title">
                                Qual é o nível de atividade física do avaliado?
                            </div>
                            <div className="question-item" style={{ marginLeft: 5 }}>
                                <div className="answer-container" style={{ marginTop: 10, flexDirection: 'column' }}>
                                    <label className="answer-item">
                                        <input className="answer-radio" type="radio" name="fatorAtividade" value="sedentario" checked={fatorAtividade === 'sedentario'} onChange={e => setFatorAtividade(e.target.value)} />
                                        <p className="answer-title">Sedentário</p>
                                    </label>
                                    <label className="answer-item">
                                        <input className="answer-radio" type="radio" name="fatorAtividade" value="leve" checked={fatorAtividade === 'leve'} onChange={e => setFatorAtividade(e.target.value)} />
                                        <p className="answer-title">Levemente ativo</p>
                                    </label>
                                    <label className="answer-item">
                                        <input className="answer-radio" type="radio" name="fatorAtividade" value="moderada" checked={fatorAtividade === 'moderada'} onChange={e => setFatorAtividade(e.target.value)} />
                                        <p className="answer-title">Moderadamente ativo</p>
                                    </label>
                                    <label className="answer-item">
                                        <input className="answer-radio" type="radio" name="fatorAtividade" value="alta" checked={fatorAtividade === 'alta'} onChange={e => setFatorAtividade(e.target.value)} />
                                        <p className="answer-title">Altamente ativo</p>
                                    </label>
                                    <label className="answer-item">
                                        <input className="answer-radio" type="radio" name="fatorAtividade" value="extrema" checked={fatorAtividade === 'extrema'} onChange={e => setFatorAtividade(e.target.value)} />
                                        <p className="answer-title">Extremamente ativo</p>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="questions-33 max-height-500px">
                            <div className="standard-title">
                                Gasto energético total (GET)
                                <div className="info-box-container" onMouseEnter={() => setShowInfoConicidade(true)} onMouseLeave={() => setShowInfoConicidade(false)}>
                                    <div className="info-icon">
                                        <HelpCircle className="info-icon-title" size={20} style={{ marginLeft: '5px' }} />
                                    </div>
                                    {showInfoConicidade && (
                                        <div className="info-box-content" style={{ transform: 'translateX(-350px) translateY(305px)' }}>
                                            <p className="">
                                                Gasto Energético Total (GET) é a soma de todas as calorias que o corpo consome ao longo do dia. Ele inclui a Taxa Metabólica Basal (TMB),
                                                o gasto com atividades físicas, e a energia utilizada na digestão dos alimentos (efeito térmico dos alimentos). Estimar o GET é fundamental
                                                para orientar estratégias de emagrecimento, manutenção ou ganho de peso.<br /><br />
                                                TMB: Taxa metabólica basal<br />
                                                GEAF: Gasto energético com atividade física<br />
                                                ETA: Efeito térmico da alimentação
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="get-container">
                                <PieChart width={160} height={160}>
                                    <Pie
                                        data={faixasGET}
                                        cx="50%"
                                        cy="50%"
                                        innerRadius={45} // Define o "furo" do gráfico (donut)
                                        outerRadius={80} // Tamanho total do gráfico
                                        startAngle={90} // Começa do topo
                                        endAngle={90 + 360} // Progresso
                                        dataKey="value"
                                        stroke="none"
                                    >
                                        {faixasGET.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                </PieChart>
                                <div className="legend pad-top-10">
                                    {faixasGET.map((item, index) => (
                                        <div key={index} className="legend-item">
                                            <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                                            {item.name} : {item.value.toLocaleString('pt-BR', { maximumFractionDigits: 0 })} Kcal
                                        </div>
                                    ))}
                                </div>
                                <p className="antropometria-result">GET: {GET.toLocaleString('pt-BR', { maximumFractionDigits: 0 })} Kcal</p>
                            </div>
                        </div>
                    </div>
                )}

                <Modal
                    isOpen={isNextModal}
                    onRequestClose={closeNextModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    <p className="popupNext-h1">Antropometria finalizada! </p>
                    <p className="popupNext-h2">Deseja ir para a Composição Corporal?</p>
                    <div className="sub-pagination-buttons">
                        <button className="next-prev-button" type="button" onClick={toComposicaoCorporal}>
                            Sim
                        </button>
                        <button className="next-prev-button" type="button" onClick={closeNextModal}>
                            Não
                        </button>
                    </div>
                </Modal>

                <div className="pagination-footer">
                    <div className="sub-pagination-footer">
                        <div className="sub-pagination-buttons">
                            {etapa > 0 && (
                                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                                    Voltar
                                </button>
                            )}
                            {etapa < 4 ? (
                                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                                    Avançar
                                </button>
                            ) : (
                                <button className="next-prev-button" type="button" onClick={handleAntropometriaRegister}>Registrar</button>
                            )}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
                        </div>
                    </div>
                    <div className="info-box-container">
                        {etapa === 1 && (
                            <div>
                                <div className="info-button" onMouseEnter={() => setShowProcedimentos(true)} onMouseLeave={() => setShowProcedimentos(false)}>
                                    <AlertCircle size={20} />
                                    Procedimentos e Precauções
                                </div>
                                {showProcedimentos && (
                                    <div className="info-box-content">
                                        <p className="">
                                            1. Marcar corretamente, os pontos dos perímetros utilizando lápis dermográfico ou caneta;<br />
                                            2. Medir sempre num ponto fixo, pois a variação aponta erros; <br />
                                            3. Medir sempre que possível sobre a pele nua; <br />
                                            4. Nunca utilizar fita elástica ou de baixa flexibilidade; <br />
                                            5. Não esquecer o dedo entre a fita e a pele; <br />
                                            6. Não dar pressão excessiva nem deixar a fita frouxa; <br />
                                            7. Realizar três medidas e calcular a média aritmética entre elas; <br />
                                            8. Não medir o avaliado após qualquer tipo de atividade física<br />
                                            9. Não deixar o dedo entre a fita e a pele; <br />
                                            10. Realizar a leitura com a aproximação de milímetros;<br />
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}
                        <div>
                            <div className="info-button" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                                <HelpCircle size={20} />
                                Mais informações
                            </div>
                            {showInfo && (
                                <div className="info-box-content">
                                    {etapa === 1 && (
                                        <div>
                                            <p className="">
                                                Os perímetros são medidas que determinam valores de circunferências de determinado segmento corporal. São importantes medidas de
                                                crescimento, podem fornecer informações sobre o estado nutricional do indivíduo e níveis de distribuição de gordura corporal
                                                (GUEDES, 2013; PELEGRINI et al., 2015).0 <br></br>Consiste em encontrar o perímetro máximo de um segmento corporal quando medido em ângulo reto em relação ao seu maior eixo.
                                            </p>
                                            <p className="">
                                                • Instrumento: fita métrica flexível com precisão de 1 milímetro
                                            </p>
                                        </div>
                                    )}
                                    {etapa !== 1 && (
                                        <div>
                                            <p className="">
                                                Os indicadores antropométricos são ferramentas utilizadas para avaliar a composição corporal e o risco de
                                                desenvolvimento de doenças crônicas. Por meio de fórmulas baseadas em medidas simples como peso,
                                                altura e circunferências, é possível estimar níveis de gordura corporal, distribuição de gordura e riscos
                                                metabólicos. Esses dados são fundamentais para o planejamento de estratégias de treinamento, nutrição e
                                                acompanhamento da saúde geral do indivíduo.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );

}

export default AntropometriaGeral;
